import React, { Component } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

class Terms extends Component {
  render() {
    const { auth } = this.props;

    const style = {
      imageHero: {
        backgroundImage: `url("/images/tikki-background.jpg")`,
        // backgroundImage: `url(${randomProperty(projects).imageHero})`,
        backgroundPosition: "center center no-repeat",
        backgroundSize: "cover",
        minHeight: 450,
        maxHeight: 450
      }
    };

    const styleSummary = {
      backgroundColor: "#A2D9D6",
      padding: "25px",
      borderRadius: "5px",
      MozBorderRadius: "5px",
      WebkitBorderRadius: "5px"
    };

    const styleTitle = {
      // backgroundColor: "#CFE89C",
      // padding: "10px",
      // borderRadius: "5px",
      // MozBorderRadius: "5px",
      // WebkitBorderRadius: "5px"
    };

    const styleBlockquote = {
      fontSize: "1em"
    };

    return (
      <div>
        <Header auth={auth} />
        <div style={style.imageHero} />
        <div className="about-main tikki-shadow">
          <h3>TERMS & CONDITIONS</h3>
          <h4 style={styleTitle}>Introduction</h4>
          <p style={styleSummary}>
            Please read the following Terms as they contain important
            information about your rights and obligations
          </p>
          <p>Tikki is operated by Tikki Global Ltd (ABN 79 624 120 494).</p>
          <p>
            Our website is an online platform connecting donors and volunteers
            to fund non-profit projects.
          </p>
          <p>
            By accessing this website and using Tikki, you agree to be legally
            bound by these terms and conditions, as modified from time to time.
            If you breach them, then your permission to use this website
            terminates immediately and we retain the right to deny further
            access.
          </p>
          <p>
            For the purpose of using the Platform, you will be required to
            provide certain personal information. This information is needed by
            Tikki in order to provide the Platform, including the provision of
            information updates, as well as your use of the service, and will be
            held and used in accordance with Tikki’s Privacy Policy as found on
            the Tikki website for your perusal. You agree that you will supply
            accurate and complete information to the Platform, and that you will
            update that information promptly if it changes.
          </p>
          <p>
            Tikki reserves the right to make changes or corrections, alter,
            suspend or discontinue any aspect of the website or the content or
            services available through it, including your access to it.
          </p>
          <h4 style={styleTitle}>General Information</h4>
          <h5>Entire agreement</h5>
          <p>
            These Terms, together with the Tikki Privacy Policy and the terms of
            any other notices or instructions given to You under these Terms of
            Use, supersede and extinguish all prior agreements, representations
            (whether oral or written), and understandings and constitute the
            entire agreement between You and Tikki relating to the Services and
            the other matters dealt with in these Terms.
          </p>
          <h5>Delays</h5>
          <p>
            Your donation is a gift, and therefore based on goodwill. The
            non-profits will do their best to conform to the delivery dates and
            expectations published on their project page. Tikki is not liable
            for any delays in project delivery.
          </p>
          <h5>No Assignment</h5>
          <p>
            You may not assign or transfer any rights to any other person
            without Tikki prior written consent.
          </p>
          <h5>Governing law and jurisdiction</h5>
          <p>
            This Agreement will be governed by the laws of Australia and You
            submit to the exclusive jurisdiction of the courts of Australia and
            where possible in the state of Victoria for all disputes arising out
            of or in connection with this Agreement.
          </p>
          <h5>Severability</h5>
          <p>
            If any part or provision of these Terms is invalid, or in conflict
            with the law, that part or provision is replaced with a provision
            which, as far as possible, accomplishes the original purpose of that
            part or provision. The remainder of this Agreement will be binding
            on the parties.
          </p>
          <h5>Notices</h5>
          <p>
            Any notice given under these Terms by either party to the other must
            be in writing by email and will be deemed to have been given on
            transmission. Notices to Tikki must be sent via website contact
            details or to any other email address notified by email to You by
            Tikki. Notices to You will be sent to the email address of the
            “account email” which You provided when setting up Your access to
            the Service.
          </p>
          <h5>Rights of Third Parties</h5>
          <p>
            A person who is not a party to these Terms has no right to benefit
            under or to enforce any term of these Terms.
          </p>
          <h4 style={styleTitle}>Use of the Platform</h4>
          <h5>Registration and Access</h5>
          <p>
            Tikki grants you the right to access and use the website for your
            assigned user profile.
          </p>
          <p>
            Tikki will make the Platform available for access and use by you to
            create a single user profile in accordance with these terms and
            conditions.
          </p>
          <p>
            Tikki hereby provides you a non-transferable, non-exclusive right to
            access and use the Platform for the sole purpose of donating and/or
            sharing your project and activities with other Tikki users.
          </p>
          <p>
            You may use the Platform in order to to connect with other Tikki
            users. You are responsible for ensuring all reasonable efforts are
            made to update your profile.
          </p>
          <p>
            You are entitled to only promote your projects within your Tikki
            Project Page. You will not insert advertisements or offers within
            other areas of the Website.
          </p>
          <p>
            You acknowledge that other Tikki users as well as members of the
            public will be able to see your Project Page and therefore it is
            your responsibility to ensure the information your provide is
            correct and kept up-to-date, and contains no misleading, unlawful,
            defamatory, confronting or even unpleasant material that is directed
            against anyone else.
          </p>
          <p>
            Tikki is entitled to suspend or terminate your access to and use of
            the Platform and/or delete any content in your Project Page if you
            or any of your personnel fail to comply with any of your obligations
            under this Agreement. Tikki will have no liability to you for its
            decision in good faith to exercise any of its rights under this
            clause.
          </p>
          <p>
            Tikki or those authorised by it to do so may gather information from
            your Project Page or User Profile and from all other areas of the
            Platform in a depersonalised form, collected for the purpose of
            research and the provision of services and information regarding
            other services to you and other users.
          </p>
          <p>
            The Tikki Platform’s functionality will change and may introduce new
            requirements for the access to and use of any new or existing
            features of functionalities of the Platform. If any such
            requirements are introduced, you will be notified through the
            Platform.
          </p>
          <h4 style={styleTitle}>Your obligations</h4>
          <h5>Unacceptable activity</h5>
          <p>
            You must ensure that all usernames and passwords required to access
            the Platform are kept secure and confidential. You must immediately
            notify Tikki of any unauthorised use of your password or any other
            breach of security. In this event Tikki will reset your password.
          </p>
          <p>
            As a condition of these Terms and Conditions, when accessing and
            using the Platform, You must:
          </p>
          <blockquote style={styleBlockquote}>
            <p>
              I. not attempt to undermine the security or integrity of Tikki’s
              Platform or Services hosted by a third party;
            </p>
            <p>
              II. not use, or misuse, the Platform in any way which may impair
              the functionality of the Services or Platform, or other systems
              used to deliver the Services or impair the ability of any other
              user to use the Platform;
            </p>
            <p>
              III. not interfere or attempt to interfere with the proper
              functioning of the Platform or connect to or use the Platform in
              any way not expressly permitted by these terms and conditions;
            </p>
            <p>
              IV. not use any unauthorised third party software that accesses,
              intercepts, "mines", or otherwise collects information from or
              through the Platform;
            </p>
            <p>
              V. not attempt to gain unauthorised access to any materials other
              than those to which You have been given express permission to;
            </p>
            <p>
              VI. not transmit, or input into the Platform, any files that may
              damage any other person's device, content that may be offensive,
              or material or Data in violation of any law (including You do not
              have the right to use); and
            </p>
            <p>
              VII. not attempt to modify, copy, adapt, reproduce, disassemble,
              decompile or reverse engineer the Tikki Platform except as is
              strictly necessary for normal operation.
            </p>
          </blockquote>
          <p>
            You must comply with any requests for information, recommendations
            and guidelines with respect to access to and use of the Platform,
            including any adjustments or replacements required in respect to
            your Customer Data and User profile;
          </p>
          <p>
            You must ensure that your personnel are adequately trained and
            informed so as to use the Platform and features effectively and in
            accordance with the Tikki onboarding;
          </p>
          <p>
            You will comply with all applicable local, state, federal and
            territorial laws in accessing and using the Platform;
          </p>
          <p>
            You will have sole responsibility for the accuracy, quality,
            integrity, legality, reliability, and appropriateness of all your
            Customer Data and accept sole responsibility for errors in the
            operation of the Platform arising from failure to maintain the
            accuracy of your Customer Data;
          </p>
          <p>
            You must own or have the right to submit Customer Data for
            publication on the Tikki Platform and all Content submitted by you
            must be legal, honest, decent and truthful and comply with all
            applicable laws, Regulations, standards and/or codes of practice;
          </p>
          <p>
            You warrant that all Customer Data submitted to us does not infringe
            the copyright, design, privacy, publicity, data protection, trade
            mark or any other rights of any third party, nor be obscene,
            abusive, threatening or defamatory of any person or be otherwise
            unlawful.
          </p>
          <h4 style={styleTitle}>Funds / Payment Procedures</h4>
          <h5>Payment</h5>
          <p>
            Payments to non-profits are made using Stripe. Fees associated with
            the Stripe payment will be covered by the donor. No fees are
            gathered by Tikki for donations.
          </p>
          <p>
            Tikki is entitled to refuse to process any donations. Acceptance of
            each donation is by a confirmation email. Once a donation is
            confirmed on the Platform refund requests are only allowable within
            48 hours by email by utilising the email or form on the Tikki
            Contact page. Please note the credit card fee charged on the
            original donation will not be refunded.
          </p>
          <h4 style={styleTitle}>Website Content</h4>
          <h5>Registration / Access</h5>
          <p>
            Cookies are standard for storing small pieces of data and Tikki may
            also use Google Analytics cookies for the website.
          </p>
          <p>
            Whilst Tikki intends that the Services should be available 24 hours
            a day, seven days a week, it is possible that on occasions the
            Services or Website may be unavailable to permit maintenance or
            other development activity to take place. Tikki will make all
            reasonable endeavours to ensure that Platform down time is
            minimised.
          </p>
          <h5>Accuracy</h5>
          <p>
            We will use our best endeavours to ensure that materials and
            information published on our website are accurate, noting that some
            content provided to us is uploaded by Tikki in good faith, on an ‘as
            is’ basis.
          </p>
          <h4 style={styleTitle}>Trademarks and Copyright</h4>
          <h5>Intellectual Property rights</h5>
          <p>
            All trademarks and logos supplied on this website which are not
            owned by Tikki remain the property of their respective owners and
            may not be used by you in connection with any other product or
            service that is not ours. Any right to use any of these associated
            trader names or trademarks of goods or services requires prior
            written consent from the owner.
          </p>
          <p>
            You may download material from our website for the sole purpose of
            using our Services. However, you may not modify, copy, reproduce,
            republish, upload, post, transmit or distribute any material or
            information from our website.
          </p>
          <h5>General</h5>
          <p>
            Title to, and all Intellectual Property Rights in the Services, the
            Website and any documentation relating to the Services remain the
            property of Tikki (or its related entities or licensors).
          </p>
          <h5>Ownership of Data</h5>
          <p>
            Title to, and all Intellectual Property Rights in, the Data remain
            Your property. However, Your access to the Data is contingent. You
            grant Tikki a license to use, copy, transmit, store, and back-up
            Your information and Data for the purposes of enabling You to access
            and use the Services and for any other purpose related to provision
            of services to You.
          </p>
          <h5>Third party data</h5>
          <p>
            Tikki provides data from third parties for Your use within the terms
            of this Service Agreement. Third party data, such as (but not
            limited to) data sourced from manufacturers of technology products
            and suppliers thereof remains the property of the copyright owner at
            all times and may not be transferred to other systems without
            written authorisation from Tikki and the copyright owner.
          </p>
          <h5>Backup of Data</h5>
          <p>
            Tikki adheres to its best practice policies and procedures to
            prevent data loss, including a daily system data back-up regime, but
            does not make any guarantees that there will be no loss of Data.
            Tikki expressly excludes liability for any loss of Data no matter
            how caused.
          </p>
          <h4 style={styleTitle}>Photography</h4>
          <p>
            By signing up to Tikki you grant as a licence for unrestricted usage
            of your photos, unless otherwise agreed with us. We would only ever
            use them in relation to Tikki and would not pass them on or use them
            for anything unrelated to Tikki.
          </p>
          <h4 style={styleTitle}>Funds and use of funds </h4>
          <h5>Payment</h5>
          <p>
            Tikki makes no representations or warranties in relation to the
            appropriate use by non-profits of funds raised by use of the site or
            the services provided. Non-profits make no representations or
            warranties in relation to the specific use of funds raised except in
            circumstances where the organisation has expressly stated that funds
            raised will be applied to a particular project or appeal.
          </p>
          <h4 style={styleTitle}>Accuracy</h4>
          <p>
            Neither Tikki nor any third parties provide any warranty or
            guarantee as to the accuracy, timeliness, performance, completeness
            or suitability of the information and materials found or offered on
            this Platform for any particular purpose. You acknowledge that such
            information and materials may contain inaccuracies or errors and we
            expressly exclude liability for any such inaccuracies or errors to
            the fullest extent permitted by law.
          </p>
          <h4 style={styleTitle}>Warranties and Acknowledgements</h4>
          <h5>Warranties</h5>
          <h5>Authority</h5>
          <p>
            You warrant that where You have registered to use the Service on
            behalf of another person, You have the authority to agree to these
            Terms on behalf of that person and agree that by registering to use
            the Service You bind the person on whose behalf You act to the
            performance of any and all obligations that You become subject to by
            virtue of these Terms, without limiting Your own personal
            obligations under these Terms.
          </p>
          <p>[Liability]</p>
          <h5>Acknowledgement</h5>
          <p>You acknowledge that:</p>
          <blockquote style={styleBlockquote}>
            <p>
              I. You are authorised to use the Services and the Website and to
              access the information and Data that You input into the Website,
              including any information or Data input into the Website by any
              person you have authorised to use the Service. You are also
              authorised to access the processed information and Data that is
              made available to You through Your use of the Website and the
              Services (whether that information and Data is Your own or that of
              anyone else).
            </p>
            <p>
              II. Tikki has no responsibility to any person other than You and
              nothing in this Agreement confers, or purports to confer, a
              benefit on any person other than You. If You use the Services or
              access the Website on behalf of or for the benefit of anyone other
              than yourself (whether a body corporate or otherwise) you agree
              that:
            </p>
            <blockquote style={styleBlockquote}>
              <p>
                ▪ You are responsible for ensuring that You have the right to do
                so; ▪ You are responsible for authorising any person who is
                given access to information or Data, and you agree that Tikki
                has no obligation to provide any person access to such
                information or Data without Your authorisation and may refer any
                requests for information to You to address; and [Indemnity]
              </p>
              <p>
                ▪ You will indemnify Tikki against any claims or loss relating
                to:
              </p>
              <blockquote style={styleBlockquote}>
                <p>
                  i. Tikki's refusal to provide any person access to Your
                  information or Data in accordance with these Terms,
                </p>
                <p>
                  ii. Tikki making available information or Data to any person
                  with Your authorisation.
                </p>
                <p>
                  III. The provision of, access to, and use of, the Services is
                  on an "as is" basis and at Your own risk.
                </p>
                <p>
                  IV. Tikki does not warrant that the use of the Service will be
                  uninterrupted or error free. Among other things, the operation
                  and availability of the systems used for accessing the
                  Service, including public telephone services, computer
                  networks and the Internet, can be unpredictable and may from
                  time to time interfere with or prevent access to the Services.
                  Tikki is not in any way responsible for any such interference
                  or prevention of Your access or use of the Services.
                </p>
                <p>
                  V. Tikki is not Your advisor and use of the Website or
                  Services does not constitute the receipt of business advice.
                </p>
                <p>
                  VI. It is Your sole responsibility to determine that the
                  Website and Services meet the needs of Your business and are
                  suitable for the purposes for which they are used.
                </p>
                <p>
                  VII. You remain solely responsible for complying with all
                  applicable accounting, tax and other laws. It is Your
                  responsibility to check that storage of and access to your
                  Data via the Software and the Website will comply with laws
                  applicable to you (including any laws requiring you to retain
                  records).
                </p>
              </blockquote>
            </blockquote>
          </blockquote>
          <h5>No warranties</h5>
          <p>
            Tikki gives no warranty about the Services. Without limiting the
            foregoing, Tikki does not warrant that the Services will meet Your
            requirements or that it will be suitable for any particular purpose.
            To avoid doubt, all implied conditions or warranties are excluded in
            so far as is permitted by law, including (without limitation)
            warranties of merchantability, fitness for purpose, title and
            non-infringement.
          </p>
          <h5>Consumer guarantees</h5>
          <p>
            You warrant and represent that You are acquiring the right to access
            and use the Services for the purposes of a business and that, to the
            maximum extent permitted by law, any statutory consumer guarantees
            or legislation intended to protect non-business consumers in any
            jurisdiction does not apply to the supply of the Services, the
            Website or these Terms.
          </p>
          <h4 style={styleTitle}>Limitation of Liability</h4>
          <h5>Liability</h5>
          <p>
            To the maximum extent permitted by law, Tikki excludes all liability
            and responsibility to You (or any other person) in contract, tort
            (including negligence), or otherwise, for any loss (including loss
            of information, Data, profits and savings) or damage resulting,
            directly or indirectly, from any use of, or reliance on, the Service
            or Website.
          </p>
          <p>
            If You suffer loss or damage as a result of Tikki’s negligence or
            failure to comply with these Terms, any claim by You against Tikki
            arising from Tikki’s negligence or failure will be limited in
            respect of any one incident, or series of connected incidents, to
            the money paid by You in the previous 12 months.
          </p>
          <p>
            If You are not satisfied with the Service, Your sole and exclusive
            remedy is to terminate these Terms.
          </p>
          <h4 style={styleTitle}>Comments and feedback</h4>
          <h5>Unacceptable activity / Liability</h5>
          <p>
            Tikki wants the website to work for everyone therefore has the right
            to remove any defamatory or obscene comments which may upset others.
            Tikki accepts no liability for consequences such as loss or damage
            arising from any comments posted by you or any third party.
          </p>
          <p>
            This site is as secure as we can reasonably make it using encryption
            technology and adopting security and anti-virus practices routinely
            used and adopted as a matter of good practice. However, you should
            understand that every internet site, and any computer that connects
            to the internet, as well as all internet communication, is
            susceptible to attack by computer hackers and viruses. We will do
            all we reasonably can to protect this site and all internet
            communications passing between us and you, but we cannot be held
            responsible for loss or damage arising from its use.
          </p>
          <h4 style={styleTitle}>Definitions</h4>
          <p>"Agreement" means these terms and conditions of use.</p>
          <p>
            "Confidential Information" includes all information exchanged
            between the parties to this Agreement, whether in writing,
            electronically or orally, including the Service but does not include
            information which is, or becomes, publicly available other than
            through unauthorised disclosure by the other party.
          </p>
          <p>
            "Customer Account" means your account information entered into the
            Platform by you and any fees applicable in accordance with the
            licensing agreement.
          </p>
          <p>
            "Customer Data" means all information provided by you and your
            personnel to the Tikki Platform.
          </p>
          <p>
            "Data" means any data inputted by You or with Your authority from
            other parties into the Website.
          </p>
          <p>
            “Fees” means the fees payable by you to use the Platform in
            accordance with the agreement and features subscribed to your
            account.
          </p>
          <p>
            "Intellectual Property Right" means any patent, trade mark, service
            mark, copyright, moral right, right in a design, know-how and any
            other intellectual or industrial property rights, anywhere in the
            world whether or not registered.
          </p>
          <p>
            "Platform" means the online, web-based sharing and connection
            interface and infrastructure.
          </p>
          <p>
            "Privacy Laws" means the Privacy Act 1988 and all rules, guidelines,
            orders, directions, directives, codes of conduct or other
            instruments made or issued thereunder, and "Personal Information"
            has the same meaning as defined therein.
          </p>
          <p>
            “Project Page” means the area within the Tikki platform that is set
            aside for your project promotion under this agreement. Only you, and
            your approved users, have access to your Project Page for the
            purposes of editing and updating.
          </p>
          <p>
            "Service" means the eCommerce, quoting, procurement and other
            services made available (as may be changed or updated from time to
            time by Tikki) via the Website.
          </p>
          <p>"Website" means any Internet site provided by Tikki.</p>
          <p>
            "Tikki" mean Tikki Global Ltd (ABN 79 624 120 494) which is
            registered in Australia.
          </p>
          <p>
            "User Profile" means the area within the Tikki platform that is set
            aside for your personnel details under this agreement. Only you have
            access to your profile for the purpose of editing and updating.
          </p>
          <p>
            "You/Your" means any person who has created his, her or its own
            Customer Account on the Platform. Tikki users other than yourself
            cannot edit your profile or your account details.
          </p>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/pages/TermsPage.js